/**
 * How many things wait for the administrator on the firm's addresses (#420): places a
 * dispatcher or a driver placed or changed, and drivers' reports. The count beside Адреси in
 * the settings sidebar, and the notice at sign-in.
 *
 * Asked once a minute and whenever a screen says the places changed — kept current while the
 * administrator is signed in, which is what the issue asks of it, without a hub message for a
 * number nobody watches by the second. Null for anyone the server refuses, who then sees
 * neither: the console asks rather than reading a role.
 */

import { useEffect, useState } from 'react';

import { onPlacesChanged, placesApi } from './api';

/** How often the count is asked again. */
const EVERY_MS = 60_000;

export function useWaitingPlaces(enabled: boolean): number | null {
  const [waiting, setWaiting] = useState<number | null>(null);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    const ask = () => {
      placesApi
        .waiting()
        .then((answer) => {
          if (!cancelled) setWaiting(answer.waiting);
        })
        .catch(() => undefined);
    };

    ask();
    const timer = globalThis.setInterval(ask, EVERY_MS);
    const stop = onPlacesChanged(ask);

    return () => {
      cancelled = true;
      globalThis.clearInterval(timer);
      stop();
    };
  }, [enabled]);

  return enabled ? waiting : null;
}
